import { useState } from "react";

const useDocumentHandler = () => {
  const [documents, setDocuments] = useState([]);
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingCertificate, setLoadingCertificate] = useState(false);

  const handleFileChange = (file, type) => {
    setLoading(true);
    setTimeout(() => {
      if (type === "cedula") {
        setDocuments((prevDocuments) => [...prevDocuments, file]);
      } else if (type === "cv") {
        setDocuments([]);
      }
      setLoading(false);
    }, 2000);
  };

  const handleCertificateChange = (file) => {
    setLoadingCertificate(true);
    setTimeout(() => {
      setCertificates((prevCertificates) => [...prevCertificates, file]);
      setLoadingCertificate(false);
    }, 2000);
  };

  const handleDocumentDelete = (index) => {
    setDocuments((prevDocuments) =>
      prevDocuments.filter((_, i) => i !== index)
    );
  };

  const handleCertificateDelete = (index) => {
    setCertificates((prevCertificates) =>
      prevCertificates.filter((_, i) => i !== index)
    );
  };

  return {
    documents,
    certificates,
    loading,
    loadingCertificate,
    handleFileChange,
    handleDocumentDelete,
    handleCertificateChange,
    handleCertificateDelete,
    setDocuments,
    setCertificates,
  };
};

export default useDocumentHandler;
